import { render, staticRenderFns } from "./DeleteFeeType.vue?vue&type=template&id=6dce149f&scoped=true"
import script from "./DeleteFeeType.vue?vue&type=script&lang=js"
export * from "./DeleteFeeType.vue?vue&type=script&lang=js"
import style0 from "./DeleteFeeType.vue?vue&type=style&index=0&id=6dce149f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dce149f",
  null
  
)

export default component.exports